import React from 'react';
import { useIntl } from 'react-intl';

import GITW2024 from '@/assets/generations-in-the-wild/Outdoorsy-GITW-2024.gif';
import {
  ContactUs,
  IssuuReport,
  OutdoorsInsights,
  OutdoorsyAchievements,
} from '@/components/route/generations-in-the-wild';
import HeadMeta from '@/components/static-pages/HeadMeta';

const GenerationsInTheWild = () => {
  const intl = useIntl();
  const seoTitle = intl.formatMessage({
    defaultMessage: 'Generations in the Wild 2024',
    id: '5w6VoQ',
  });
  const seoDescription = intl.formatMessage({
    defaultMessage:
      'A research report exploring the motivations and benefits that road trips and time spent outdoors brings four generations of American families.',
    id: 'zAtjMk',
  });

  return (
    <>
      <HeadMeta title={seoTitle} description={seoDescription} thumbnailURL={GITW2024} />
      <IssuuReport />
      <OutdoorsInsights />
      <ContactUs />
      <OutdoorsyAchievements />
    </>
  );
};

export default GenerationsInTheWild;
